import {
  convertDateRangesToMarkdown,
  findTimelineGaps,
  getApplicantRequiredDuration,
} from 'helpers/date';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { residenceAddressNameFields } from 'constants/enums/people';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { HistoryResidenceModel } from './types';
import historyResidenceItemValidator from './validators/item';

const historyResidenceValidator: ValidateJSModel<HistoryResidenceModel> = {
  List: (value, attributes, attributeName, options) => {
    let additionalValidation = {};
    const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, residenceAddressNameFields);
    if (errors.length > 0) {
      additionalValidation = {
        requireTrue: { // force error message; value will never be true
          message: 'relationships.people.error.duplicateListItems',
        }
      };
    }

    return {
      ...additionalValidation,
      presence: true,
      accordion: { validator: historyResidenceItemValidator },
      durationCoverage: (value, attributes, attributeName, options2) => {
        const {
          requireYears, applicantBirthdate, formType
        } = options2;
        const { coverage, requiredYears: years } = getApplicantRequiredDuration({
          requiredDuration: { years: requireYears ?? 0 }, applicantBirthdate, formType, type: 'residence'
        });

        const validResidenceDates = value?.items?.map((i) => i?.Item?.Dates) ?? [];

        const gaps = findTimelineGaps(coverage, validResidenceDates);

        const presentChecked = value?.items?.some((element) => element?.Item?.Dates?.present === true);

        return {
          requirePresent: !presentChecked,
          requirePresentMessage: 'error.presentUnchecked.historyResidence',
          requiredDuration: coverage,
          incompleteDuration: {
            code: 'error.gap.historyResidence',
            localeOptions: {
              messageParameters: {
                years,
                gaps: convertDateRangesToMarkdown(gaps),
              },
            },
          },
        };
      },
    };
  }
};

export default historyResidenceValidator;
